import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../shared/table/pagination/Pagination';
import {
  nextPublicNotesPageAction,
  prevPublicNotesPageAction,
  setPublicNotesPageSizeAction,
} from '../../redux/actions/notesActions';

const PublicNotesPagination = () => {
  const pageable = useSelector((state) => state.notes?.publicNotesPageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextPublicNotesPageAction}
      onPrevPageClickAction={prevPublicNotesPageAction}
      onPageSizeChangeAction={setPublicNotesPageSizeAction}
    />
  );
};

export default PublicNotesPagination;
